export const billingProfileHc = {
  datosFacturacion: {
    titulo: "بيانات الفوترة",
    requeridos: "بيانات الفوترة مطلوبة",
  },
  perfil: {
    swalTitle: "تحقق من بريدك الإلكتروني",
    swalText:
      "لمتابعة تغيير كلمة المرور، تحقق من صندوق الوارد واتبع الخطوات",
    swalConfirm: "متابعة",
    errorInesperado: "عذرًا! حدث خطأ غير متوقع",
  },
  facturacionCuenta: {
    editarInfo: "تعديل المعلومات",
    direccionLinea1: "سطر العنوان 1",
    direccionLinea2: "سطر العنوان 2 (اختياري)",
    cancelar: "إلغاء",
    guardando: "جارٍ الحفظ...",
    guardarCambios: "حفظ التغييرات",
    errorCargar: "حدث خطأ أثناء تحميل بيانات الفوترة",
    actualizadoOk: "تم تحديث البيانات بنجاح",
    errorActualizar: "حدث خطأ أثناء التحديث",
    errorActualizarDatos: "حدث خطأ أثناء تحديث البيانات",
  },
};
